import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import config from '../config/config';

export function EditRegistration() {
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    customer_name: '',
    phone: '',
    address: '',
    shares: []
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${config.baseUrl}/api/qurbani/registration/${location.state?.data?.[0]?.id}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        const data = await response.json();
        setFormData({
          id: data.id,
          customer_name: data.customer_name,
          phone: data.phone,
          address: data.address,
          shares: Array.isArray(data.shares) ? data.shares : []
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    if (location.state?.data?.[0]?.id) {
      fetchData();
    }
  }, [location.state?.data]);

  const handleShareChange = (index, field, value) => {
    const updatedShares = [...formData.shares];
    updatedShares[index] = {
      ...updatedShares[index],
      [field]: value
    };
    setFormData({ ...formData, shares: updatedShares });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${config.baseUrl}/api/qurbani/update-registration/${formData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          customer_name: formData.customer_name,
          phone: formData.phone,
          address: formData.address,
          shares: formData.shares.map(share => ({
            ...share,
            feasabilillah: Boolean(share.feasabilillah),
            animal_number: parseInt(share.animal_number) || 0
          }))
        })
      });

      const result = await response.json();
      if (response.ok && result.success) {
        navigate('/registration-options');
      } else {
        alert(result.error || 'Failed to update registration');
      }
    } catch (error) {
      console.error('Error updating registration:', error);
      alert('An error occurred while updating the registration');
    }
  };

  return (
    <div className="max-w-3xl mx-auto mt-8 p-6 bg-white rounded-lg shadow">
      <h1 className="text-2xl font-bold text-center mb-6">Edit Registration</h1>
      
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="space-y-4">
          <h2 className="text-xl font-semibold">Customer Information</h2>
          <div>
            <label className="block mb-2">Name</label>
            <input
              type="text"
              value={formData.customer_name || ''}
              onChange={(e) => setFormData({...formData, customer_name: e.target.value})}
              className="w-full p-2 border rounded"
            />
          </div>

          <div>
            <label className="block mb-2">Phone</label>
            <input
              type="text"
              value={formData.phone || ''}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              className="w-full p-2 border rounded"
            />
          </div>

          <div>
            <label className="block mb-2">Address</label>
            <textarea
              value={formData.address || ''}
              onChange={(e) => setFormData({...formData, address: e.target.value})}
              className="w-full p-2 border rounded"
              rows="3"
            />
          </div>
        </div>

        <div className="space-y-4">
          <h2 className="text-xl font-semibold">Share Details</h2>
          {formData.shares.map((share, index) => (
            <div key={index} className="p-4 border rounded space-y-4">
              <h3 className="font-medium">Share {index + 1}</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block mb-2">First Name</label>
                  <input
                    type="text"
                    value={share.firstname || ''}
                    onChange={(e) => handleShareChange(index, 'firstname', e.target.value)}
                    className="w-full p-2 border rounded"
                  />
                </div>

                <div>
                  <label className="block mb-2">Last Name</label>
                  <input
                    type="text"
                    value={share.lastname || ''}
                    onChange={(e) => handleShareChange(index, 'lastname', e.target.value)}
                    className="w-full p-2 border rounded"
                  />
                </div>

                <div>
                  <label className="block mb-2">Type</label>
                  <select
                    value={share.type || ''}
                    onChange={(e) => handleShareChange(index, 'type', e.target.value)}
                    className="w-full p-2 border rounded"
                  >
                    <option value="">Select Type</option>
                    <option value="cow">Cow</option>
                    <option value="camel">Camel</option>
                    <option value="goat">Goat</option>
                    <option value="sheep">Sheep</option>
                  </select>
                </div>

                <div>
                  <label className="block mb-2">Category</label>
                  <select
                    value={share.category || ''}
                    onChange={(e) => handleShareChange(index, 'category', e.target.value)}
                    className="w-full p-2 border rounded"
                  >
                    <option value="">Select Category</option>
                    <option value="A">Category A</option>
                    <option value="B">Category B</option>
                    <option value="C">Category C</option>
                  </select>
                </div>

                <div>
                  <label className="block mb-2">Slaughtering Day</label>
                  <select
                    value={share.slaughtering_day || ''}
                    onChange={(e) => handleShareChange(index, 'slaughtering_day', e.target.value)}
                    className="w-full p-2 border rounded"
                  >
                    <option value="">Select Day</option>
                    <option value="1">Day 1</option>
                    <option value="2">Day 2</option>
                    <option value="3">Day 3</option>
                  </select>
                </div>

                <div>
                  <label className="block mb-2">Animal Number</label>
                  <input
                    type="text"
                    value={share.animal_number || ''}
                    onChange={(e) => handleShareChange(index, 'animal_number', e.target.value)}
                    className="w-full p-2 border rounded"
                  />
                </div>
              </div>

              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={share.feasabilillah || false}
                  onChange={(e) => handleShareChange(index, 'feasabilillah', e.target.checked)}
                  className="w-4 h-4"
                />
                <label>Fisabilillah</label>
              </div>
            </div>
          ))}
        </div>

        <button
          type="submit"
          className="w-full py-2 bg-green-500 text-white rounded hover:bg-green-600"
        >
          Update Registration
        </button>
      </form>
    </div>
  );
}